export default __webpack_public_path__ + "static/media/Бор_40л.80ed6f74.jpg";